import { initializeAccordion } from "./helpers/initialize-accordion";

const BurgerAccordion = () => {
  initializeAccordion(".burger-menu", ".accordion", ".accordion-title", ".accordion-list-wrapper");

  const burgerMenu = document.querySelector(".burger-menu");

  if (burgerMenu) { 
    const accordionOpenableTitles = [...burgerMenu.querySelectorAll(".accordion-title.openable")];

    accordionOpenableTitles.forEach((accordionOpenableTitle) => {
      accordionOpenableTitle.addEventListener("click", (e) => {
        e.preventDefault();
      })
    })
  }
};

export default BurgerAccordion;